class ProductCardVariants {
  constructor() {
    this.init();
  }

  init() {
    document.addEventListener('click', this.handleVariantClick.bind(this));
    document.addEventListener('keydown', this.handleKeyDown.bind(this));
    this.initMobileTouchSupport();
  }

  initMobileTouchSupport() {
    if ('ontouchstart' in window) {
      const productCards = document.querySelectorAll('.product-card:has(.product-card-variants)');
      const mobileButtons = document.querySelectorAll('.product-card .quick-add-popup__toggle');
      const overlay = document.querySelector('.quick-add-popup-overlay');

      let activePopup = null; 
      let originalParent = null; 

      if (mobileButtons.length && overlay) {
        mobileButtons.forEach(button => {
          button.addEventListener('click', (e) => {
            e.preventDefault();

            const cardGallery = button.closest('.card-gallery');
            if (cardGallery) {
              const popup = cardGallery.querySelector('.product-card-variants');
              if (popup) {                
                if (activePopup && activePopup !== popup && originalParent) {
                  originalParent.prepend(activePopup);
                }                
                originalParent = popup.parentElement;
                                
                if (!overlay.contains(popup)) {
                  overlay.appendChild(popup);
                }

                overlay.classList.add('active');
                activePopup = popup;
              }
            }
          });
        });

        overlay.addEventListener('click', (e) => {
          if (e.target === overlay) {
            overlay.classList.remove('active');
            
            if (activePopup && originalParent) {
              originalParent.prepend(activePopup);
            }

            activePopup = null;
            originalParent = null;
          }
        });
      }      
    }
  }

  handleKeyDown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      const option = event.target.closest('.product-card-variants__option');
      if (option && !option.classList.contains('product-card-variants__option--unavailable')) {
        event.preventDefault();
        this.handleVariantClick(event);
      }
    }
  }

  handleVariantClick(event) {
    const option = event.target.closest('.product-card-variants__option');
    if (!option || option.classList.contains('product-card-variants__option--unavailable')) return;

    event.preventDefault();
    event.stopPropagation();

    const variantId = option.dataset.variantId;
    const productId = option.closest('.product-card-variants').dataset.productId;

    if (variantId) {
      this.addToCart(variantId, productId, event);
    }
  }

  async addToCart(variantId, productId, event) {
    try {
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');

      const cartItemsComponents = document.querySelectorAll('cart-items-component');
      let cartItemComponentsSectionIds = [];
      cartItemsComponents.forEach((item) => {
        if (item instanceof HTMLElement && item.dataset.sectionId) {
          cartItemComponentsSectionIds.push(item.dataset.sectionId);
        }
      });

      const cartDrawerComponents = document.querySelectorAll('[data-section-id]');
      cartDrawerComponents.forEach((item) => {
        if (item instanceof HTMLElement && item.dataset.sectionId) {
          const sectionId = item.dataset.sectionId;
          if (sectionId && !cartItemComponentsSectionIds.includes(sectionId)) {
            cartItemComponentsSectionIds.push(sectionId);
          }
        }
      });

      if (cartItemComponentsSectionIds.length > 0) {
        formData.append('sections', cartItemComponentsSectionIds.join(','));
      }

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'text/html',
        },
      });

      const responseData = await response.json();

      if (responseData.status) {
        if (window.CartErrorEvent) {
          window.dispatchEvent(new CartErrorEvent(productId, responseData.message));
        }
        return;
      }

      this.showSuccessFeedback(productId);

      if (responseData.sections) {
        this.updateCartSections(responseData.sections);
      }

      if (window.CartAddEvent) {
        const cartAddEvent = new CartAddEvent({}, variantId, {
          source: 'product-card-variants',
          itemCount: 1,
          productId: productId,
          sections: responseData.sections,
        });

        window.dispatchEvent(cartAddEvent);
      }

      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: {
          variantId: variantId,
          productId: productId,
          quantity: 1,
          source: 'product-card-variants',
          sections: responseData.sections
        }
      }));
      if (window.cartPerformance && window.cartPerformance.measureFromEvent) {
        window.cartPerformance.measureFromEvent('add:user-action', event);
      }

      setTimeout(() => {
        this.openCartDrawer();
      }, 100);

    } catch (error) {
      console.error('Error adding to cart:', error);
    }
  }

  updateCartSections(sections) {
    if (!sections || typeof sections !== 'object') return;

    Object.keys(sections).forEach(sectionId => {
      const sectionElement = document.querySelector(`[data-section-id="${sectionId}"]`);
      if (sectionElement && sections[sectionId]) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = sections[sectionId];

        const newSectionElement = tempDiv.querySelector(`[data-section-id="${sectionId}"]`);

        if (newSectionElement) {
          sectionElement.innerHTML = newSectionElement.innerHTML;
          this.reinitializeSection(sectionElement);
        }
      }
    });

    this.updateCartCount();
  }

  reinitializeSection(sectionElement) {
    const customElements = sectionElement.querySelectorAll('[is], [data-component]');
    customElements.forEach(element => {
      if (element.connectedCallback && typeof element.connectedCallback === 'function') {
        element.connectedCallback();
      }
    });

    sectionElement.dispatchEvent(new CustomEvent('section:updated', {
      bubbles: true,
      detail: { source: 'product-card-variants' }
    }));
  }

  updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartCountElements = document.querySelectorAll('.cart-count, [data-cart-count], .cart-count-bubble, .cart-bubble__text-count');
        cartCountElements.forEach(element => {
          element.textContent = cart.item_count;

          if (cart.item_count > 0) {
            document.querySelector('.cart-bubble')?.classList.remove('visually-hidden');
            element.classList.remove('hidden');
            element.style.display = '';
          } else {
            element.classList.add('hidden');
          }
        });

        const cartTotalElements = document.querySelectorAll('[data-cart-total]');
        cartTotalElements.forEach(element => {
          element.textContent = Shopify.formatMoney(cart.total_price);
        });
      })
      .catch(error => {
        console.error('Error updating cart count:', error);
      });
  }

  showSuccessFeedback(productId) {
    const productCard = document.querySelector(`product-card[data-product-id="${productId}"]`);
    if (productCard) {
      productCard.classList.add('product-card--added');
      setTimeout(() => {
        productCard.classList.remove('product-card--added');
      }, 2000);
    }
  }

  openCartDrawer() {
    const cartIcon = document.querySelector('.header-actions__cart-icon');
    if (cartIcon) {
      cartIcon.click();
      return;
    }

    const cartDrawerTriggers = [
      '[data-drawer-trigger="cart"]',
      '[data-cart-drawer-trigger]',
      '.cart-drawer-trigger',
      '#cart-icon-bubble',
      '.header-cart-link',
      '[aria-controls*="cart"]',
      '.cart-count-bubble',
      '.cart-link'
    ];

    for (const selector of cartDrawerTriggers) {
      const trigger = document.querySelector(selector);
      if (trigger) {
        trigger.click();
        return;
      }
    }

    const cartEvents = [
      'cart:open',
      'drawer:open:cart',
      'theme:cart:open',
      'cart:toggle'
    ];

    for (const eventName of cartEvents) {
      document.dispatchEvent(new CustomEvent(eventName, {
        bubbles: true,
        detail: { source: 'product-card-variants' }
      }));
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new ProductCardVariants());
} else {
  new ProductCardVariants();
}